import { useAlert } from '../contexts/AlertContext';
import { isNil } from '../utils/isNil';

interface Props {
  onShareSuccess?: (nativeShare: boolean) => void;
  onShareCancel?: (nativeShare: boolean) => void;
  url: string;
  title?: string;
  text?: string;
}

export const useShare = ({
  onShareCancel = () => null,
  onShareSuccess = () => null,
  title,
  text,
  url,
}: Props) => {
  const alert = useAlert();

  const handleShare = () => {
    const canShare =
      (!isNil(navigator.canShare) &&
        navigator.canShare({ title, text, url })) ||
      !isNil(navigator.share);

    if (canShare) {
      /**
       * @note catch so it doesn't throw an unhandled promise
       */
      /* eslint-disable-next-line @typescript-eslint/no-empty-function */
      return navigator
        .share({ title, text, url })
        .then(() => onShareSuccess(true))
        .catch(() => onShareCancel(true));
    }
    return navigator.clipboard
      .writeText(url)
      .then(() => {
        alert('Link copied to clipboard');
        onShareSuccess(false);
      })
      .catch(() => {
        alert('Something went wrong', 'danger');
      });
  };

  return handleShare;
};
